import { render, staticRenderFns } from "./BlockListMediaCustom.vue?vue&type=template&id=52844a71"
import script from "./BlockListMediaCustom.vue?vue&type=script&lang=js"
export * from "./BlockListMediaCustom.vue?vue&type=script&lang=js"
import style0 from "./BlockListMediaCustom.vue?vue&type=style&index=0&id=52844a71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports